//Validación por medio de expresiones regulares
//Nombres y apellidos
$(document).ready(function () {
  // Nombres
  $(".names").on("input keydown paste", function (event) {
    var inputText = $(this).val();
    var resultText = inputText.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑçÇ.\´'\ ]/g, '');
    $(this).val(resultText);
  });

  // Números (teléfonos o campos con números enteros)
  $(".numbers").on('input keydown paste', function () {
    var inputText = $(this).val();
    var resultText = inputText.replace(/[^0-9]/g, '');
    $(this).val(resultText);
  });


  // Permite carácteres propios del RFC y del CURP: Sin carácteres especiales
  $(".rfc-curp").bind("keypress", function (event) {
    if (event.charCode != 0) {
      var regex = new RegExp("^[a-zA-Z0-9]+$");
      var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if (!regex.test(key)) {
        event.preventDefault();
        return false;
      }
    }
  });

  //Permite letras y números, pues sirven para los nombres de calles
  //y números exteriores e interiores, permite algunos carácteres
  //especiales como - . #
  $(".street-names").on("input keydown paste", function (event) {

    var inputText = $(this).val();
    var resultText = inputText.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ0-9.\´'\ ]/g, '');
    $(this).val(resultText);
  });
  $(".street-names-letters").on("input keydown paste", function (event) {

    var inputText = $(this).val();
    var resultText = inputText.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ.\´\ ]/g, '');
    $(this).val(resultText);
  });


  //Restringe carácteres no propios de los correos
  //electrónicos, como espacios y signos, exceptuando
  //punto y guiones
  $(".email").bind("keypress", function (event) {
    if (event.charCode != 0) {
      var regex = new RegExp("^[a-zA-Z0-9@.-_]+$");
      var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if (!regex.test(key)) {
        event.preventDefault();
        return false;
      }
    }
  });

  //de propósito general

  $(".alpha-numeric").bind("keypress", function (event) {
    if (event.charCode != 0) {
      var regex = new RegExp("^[\-a-zA-ZáéíóúÁÉÍÓÚ'\"/0-9 ]+$");
      var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if (!regex.test(key)) {
        event.preventDefault();
        return false;
      }
    }
  });

  //únicamente alfa numéricos como folios
  $(".alpha-numeric-strict").on("input keydown paste", function (event) {
    var inputText = $(this).val();
    var resultText = inputText.replace(/[^a-zA-Z0-9\-]/g, '');
    $(this).val(resultText);
  });

  $(".coordinates").on("input keydown paste", function (event) {

    var inputText = $(this).val();
    var resultText = inputText.replace(/[^0-9\-°'\"/.,]/g, '');
    $(this).val(resultText);
  });

  //Números con decimales, permite comas y puuntos

  $(".decimal").on("input keydown paste", function (event) {

    var inputText = $(this).val();
    var resultText = inputText.replace(/[^0-9.]/g, '');
    $(this).val(resultText);
  });


  //Para descripciones
  $(".description").bind("keypress", function (event) {
    if (event.charCode != 0) {
      var regex = new RegExp("^[a-zA-Z\-ñÑáéíóúÁÉÍÓÚ0-9/*+()\",. ]+$");
      var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if (!regex.test(key)) {
        event.preventDefault();
        return false;
      }
    }
  });

  // RFC y CURP a mayúsculas
  if ($(".rfc-curp")[0])
    $('.rfc-curp').bind("keyup", function () {
      $(this).val($(this).val().toUpperCase());
    });
  //it disallows users to introduce any text, so we may ommit using readonly property.
  $('.datepicker, .datepicker-past').on("input keydown paste", function (event) {

    var inputText = $(this).val();
    var resultText = inputText.replace(/[^]/g, '');
    $(this).val(resultText);
  });

  $(".clave_catastral").on('input keydown paste', function () {
    var inputText = $(this).val();
    var resultText = inputText
      //ELIMINA ESPACIOS EN BLANCO
      .replace(/\s/g, '')
      //ELIMINA LETRAS
      .replace(/\D/g, '')
      //Ponemos espacios en blanco cada tres numeros
      .replace(/([0-9]{3})/g, '$1 ')
      //elimina el ultimo espaciado
      .trim();
    $(this).val(resultText);
  });

  $(".trim").on('input keydown paste', function () {
    var inputText = $(this).val();
    var resultText = inputText
      //elimina el ultimo espaciado
      .trim();
    $(this).val(resultText);
  });

  // Input: txt_contador - maxlenght
  $('.txt_contador').on('keyup change paste click input', function () {
    var texto = $(this).val();
    var longitudAct = texto.length;
    var longitudMax = this.maxlength;
    $('#count-' + this.id).html(longitudAct + '/' + longitudMax);
  });

  $(".long_3").keyup(function (e) {
    var max = 3;
    if ($(".long_3").val().length > max) {
      $(".long_3").val($(".long_3").val().substr(0, max));
    }
  });

  $(".long_4").keyup(function (e) {
    var max = 4;
    if ($(".long_4").val().length > max) {
      $(".long_4").val($(".long_4").val().substr(0, max));
    }
  });

  $(".long_5").keyup(function (e) {
    var max = 5;
    if ($(".long_5").val().length > max) {
      $(".long_5").val($(".long_5").val().substr(0, max));
    }
  });

  $(".long_6").keyup(function (e) {
    var max = 6;
    if ($(".long_6").val().length > max) {
      $(".long_6").val($(".long_6").val().substr(0, max));
    }
  });

  $(".long_8").keyup(function (e) {
    var max = 8;
    if ($(".long_8").val().length > max) {
      $(".long_8").val($(".long_8").val().substr(0, max));
    }
  });

  $(".long_10").keyup(function (e) {
    var max = 10;
    if ($(".long_10").val().length > max) {
      $(".long_10").val($(".long_10").val().substr(0, max));
    }
  });

  $(".long_15").keyup(function (e) {
    var max = 15;
    if ($(".long_15").val().length > max) {
      $(".long_15").val($(".long_15").val().substr(0, max));
    }
  });

  $(".long_17").keyup(function (e) {
    var max = 17;
    if ($(".long_17").val().length > max) {
      $(".long_17").val($(".long_17").val().substr(0, max));
    }
  });

  $(".long_18").keyup(function (e) {
    var max = 18;
    if ($(".long_18").val().length > max) {
      $(".long_18").val($(".long_18").val().substr(0, max));
    }
  });

  $(".long_30").keyup(function (e) {
    var max = 30;
    if ($(".long_30").val().length > max) {
      $(".long_30").val($(".long_30").val().substr(0, max));
    }
  });

  $(".long_50").keyup(function (e) {
    var max = 50;
    if ($(".long_50").val().length > max) {
      $(".long_50").val($(".long_50").val().substr(0, max));
    }
  });

  $(".long_80").keyup(function (e) {
    var max = 80;
    if ($(".long_80").val().length > max) {
      $(".long_80").val($(".long_80").val().substr(0, max));
    }
  });

  $(".long_100").keyup(function (e) {
    var max = 100;
    if ($(".long_100").val().length > max) {
      $(".long_100").val($(".long_100").val().substr(0, max));
    }
  });

  $(".long_255").keyup(function (e) {
    var max = 255;
    if ($(".long_255").val().length > max) {
      $(".long_255").val($(".long_255").val().substr(0, max));
    }
  });

  $(".long_500").keyup(function (e) {
    var max = 500;
    if ($(".long_500").val().length > max) {
      $(".long_500").val($(".long_500").val().substr(0, max));
    }
  });

  $(".dos_decimales").on('input keydown paste', function (e) {
    var input = $(this);
    var oldVal = input.val();
    var regex = new RegExp(input.attr('pattern'), 'g');

    setTimeout(function () {
      var newVal = input.val();
      if (!regex.test(newVal)) {
        input.val(oldVal);
      }
    }, 0);
  });

});
